import { render, staticRenderFns } from "./OrderCrumb.vue?vue&type=template&id=3a91c1ee&"
import script from "./OrderCrumb.vue?vue&type=script&lang=ts&"
export * from "./OrderCrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports